
export const LOCALE_STORAGE_SHOPPING_CART = 'shopping-cart-storage'
export const EVENT_SHOPPING_CART = 'shopping-cart-event'
export const SELECT_CHANGE_EVENT = 'select-change-event'

// these strings are honeypot field identifiers
export const HONEY_POT_NAME = 'secondName'
export const HONEY_POT_EMAIL = 'verificationEmail'
